import { render, staticRenderFns } from "./TeamSalesStatus.vue?vue&type=template&id=068945b0&scoped=true&"
import script from "./TeamSalesStatus.vue?vue&type=script&lang=js&"
export * from "./TeamSalesStatus.vue?vue&type=script&lang=js&"
import style0 from "./TeamSalesStatus.vue?vue&type=style&index=0&id=068945b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068945b0",
  null
  
)

export default component.exports